import * as z from "zod";
import { isValidVat } from "vat-number-validator";

const validateOrgNumber = (orgNumber: string, outsideEu: boolean): boolean => {
  if (outsideEu) return true;
  return isValidVat(orgNumber.replace(/\s/g, "").toUpperCase());
};

const PartnerSchema = z
  .object({
    orgNumber: z.string().trim().min(1, "validation:orgNumberRequired"),
    companyName: z.string().min(0),
    country: z.string().min(1, "validation:countryRequired"),
    address: z.string().min(0),
    city: z.string().min(0),
    region: z.string().min(0),
    postalCode: z.string().min(0),
    duns: z.string().min(0),
    contractTemplateIds: z.array(z.string()),
    outsideEu: z.boolean(),
  })
  .refine(
    (data) => {
      if (!data.orgNumber) return true;
      return validateOrgNumber(data.orgNumber, data.outsideEu);
    },
    {
      message: "validation:invalidOrgNumber",
      path: ["orgNumber"],
    }
  );

export const AddPartnerValidationSchema = PartnerSchema;
export type AddPartnerFormInput = z.infer<typeof PartnerSchema>;
